<template>
    <div class="col-sm-12">
        <div>
            <table class="table table-striped table-hover table-sticky-header table-responsive" v-if="data">
                <thead>
                    <tr>
                        <th>Report</th>
                        <th></th>
                        <th>Created at</th>
                        <th>Report</th>
                        <th></th>
                        <th>Heatmap</th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="row in data">
                    <td>{{row.name}}</td>
                    <td>
                        <div data-toggle="tooltip" :title="getTooltip(row)">
                            {{jobsLabel(row)}}
                        </div>
                    </td>
                    <td>{{row.generated_at ? row.generated_at : 'Building the report...'}}</td>
                    <td><a v-if="row.generated_at" :href="downloadUrl(row.key)">Download PDF</a></td>
                    <td><a v-if="row.generated_at" :href="viewUrl(row.key)">View HTML</a></td>
                    <td>
                        <a href="#reports" v-if="row.minimap_url === null" @click="generateHeatmap(row)">Generate</a>
                        <span v-else-if="!row.minimap_url">Generating...</span>
                        <a v-else :href="row.minimap_url">Download</a>
                    </td>
                    <td><a v-if="row.generated_at" :href="settingsUrl(row.key)">Settings</a></td>
                    <td><a href="#reports" @click="deleteRow(row.key)">Delete</a></td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'typeFilter',
        ],
        data() {
            return {
                pusher: {
                    all_users: null,
                },
            };
        },
        methods: {
            jobsLabel(row) {
                return row.jobsFilter.length ? row.jobsFilter.length+' job'+(row.jobsFilter.length > 1 ? 's' : '') : '';
            },
            getTooltip(row) {
                return '<ol>'+_.join(_.map(row.jobsFilter, (title) => `<li>${title}</li>`), '')+'</ol>';
            },
            downloadUrl(key) {
                return url(`business-review-reports/${key}/pdf`);
            },
            viewUrl(key) {
                return url(`business-review-reports/${key}/html`);
            },
            generateHeatmap(row) {
                row.minimap_url = '';
                return axios.post(url(`admin/heatmap/${row.key}/generate`));
            },
            settingsUrl(key) {
                return url(`business-review-reports/${key}/settings`);
            },
            deleteRow(key) {
                if (confirm('Are you sure?')) {
                    window.location.href = url(`business-review-reports/${key}/delete`);
                }
                return false;
            },
            updateHeatmapUrl(key, url) {
                let row = _.find(this.data, { key: key });
                if (typeof row !== 'undefined') {
                    row.minimap_url = url;
                }
                
            },
        },
        mounted: function () {
            $('body').tooltip({
                selector: '[data-toggle="tooltip"]',
                html: true
            });
        },
        created() {
            this.pusher.all_users = Echo.private(`jb-all-users`);
            this.pusher.all_users.listen('.heatmap-generated', (event) => {
                this.updateHeatmapUrl(event.key, event.minimap_url);
            });
        },
        beforeDestroy() {
            this.pusher.all_users.stopListening('.heatmap-generated');
        }
    }
</script>

<style>
    .tooltip-inner {
        max-width: 650px; text-align: left;
    }
</style>
